<template>
  <div class="c-entrepreneur-title-text-title" :class="{ 'c-entrepreneur-title-text-title--with-icon': isIconVisible }">
    <!-- decorative element -->
    <icon class="c-entrepreneur-title-text-title__icon" v-if="isIconVisible" icon="arrows-bended" />
    <!-- title -->
    <div class="c-entrepreneur-title-text-title__title">
      <prismic-rich-text :field="data.large_title" />
    </div>
    <!-- sub title -->
    <h3 v-if="data.sub_title && data.sub_title[0]" class="t-t3-heavy-bold | u-c-bright">{{ data.sub_title[0].text }}</h3>
  </div>
</template>

<script>
import icon from "objects/Icon";
import PrismicRichText from "objects/PrismicRichText";
export default {
  components: {
    icon,
    PrismicRichText
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    isIconVisible: {
      type: Boolean,
      required: false,
      default: false
    }
  }
};
</script>

<style lang="scss">
.c-entrepreneur-title-text-title {
  display: flex;
  flex-direction: column;
  position: static; // overwriting somethinng to allow the icon to go to the top
  &--with-icon {
    padding-top: calc(100px + var(--grid-gutter-triple));
    @media #{$breakpoint-horizontal} {
      padding-top: 0px;
    }
  }
  &__icon {
    position: absolute;
    top: 0px;
    left: var(--grid-gutter-half);
    svg {
      max-width: 100px;
    }
    @media #{$breakpoint-horizontal} {
      left: 0px;
    }
    @media #{$breakpoint-horizontal} {
      svg {
        max-width: 300px;
      }
    }
  }
  &__title {
    @include t2-heavy;
    h2 {
      margin: 0px;
    } // overwrite prisimic}
  }
  h3 {
    text-transform: uppercase;
    font-weight: 900;
    padding-top: var(--grid-gutter-half);
  }
}
</style>
